import { ActivityIndicator, SafeAreaView } from 'react-native';
import { Light } from '../../img/logos';

const CustomActivityIndicator = () => {
    return (
        <SafeAreaView style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <Light />
            <ActivityIndicator animating={true} color={'#86BC25'} />
        </SafeAreaView>
    )
}
export default CustomActivityIndicator;